import { render, staticRenderFns } from "./PatentOfficialDeadlineLogReport.vue?vue&type=template&id=32366a6c&"
import script from "./PatentOfficialDeadlineLogReport.vue?vue&type=script&lang=js&"
export * from "./PatentOfficialDeadlineLogReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports